<div class="container-global">
  <lib-ags-kendo-grid-list
    [titlefield]="'Liste des sessions'"
    [gridConfig]="gridSettings"
    [table]="'session'"
    [data]="sessionList"
    [gotoFunction]="goSession"
  >
  </lib-ags-kendo-grid-list>
</div>